import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import ResultsView from "../views/ResultsView.vue";

const routes = [
  {
    path: '/',
    name: 'game-welcome',
    component: () => import(/* webpackChunkName: "game-welcome" */ '../views/GameWelcomeView.vue')
  },
  {
    path: '/select',
    name: 'home',
    component: () => import(/* webpackChunkName: "select" */ '../views/AssetSelectorView.vue')
  },
  {
    path: '/cases',
    name: 'cases',
    component: HomeView
  },
  {
    path: '/mode',
    name: 'mode',
    component: () => import(/* webpackChunkName: "mode" */ '../views/ModeSelectView.vue')
  },
  {
    path: '/game',
    redirect: '/'
  },
  {
    path: '/game/select',
    redirect: '/select'
  },
  {
    path: '/game/cases',
    redirect: '/cases'
  },
  {
    path: '/game/mode',
    redirect: '/mode'
  },
  {
    path: '/instructions',
    name: 'instructions',
    component: () => import(/* webpackChunkName: "instructions" */ '../views/InstructionsView.vue')
  },
  {
    path: '/game/instructions',
    redirect: to => ({ path: '/instructions', query: to.query })
  },
  {
    path: '/play',
    name: 'game',
    component: () => import(/* webpackChunkName: "game" */ '../views/game/GameView.vue')
  },
  {
    path: '/game/play',
    redirect: '/play'
  },
  {
    path: '/res',
    name: 'res',
    component: ResultsView
  },
  {
    path: '/game/res',
    redirect: '/res'
  },
  {
    path: '/about',
    name: 'about',
    component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  },
  {
    path: '/:pathMatch(.*)*',
    redirect: '/'
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (to.hash) {
      return {
        el: to.hash,
      }
    }
    return { top: 0 }
  },
})

export default router
